import { render, staticRenderFns } from "./manifesto.vue?vue&type=template&id=7b1c5c64&"
import script from "./manifesto.vue?vue&type=script&lang=js&"
export * from "./manifesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports